import { http } from '@/util/HTTP';

const Http = {
  install: Vue => {
    Vue.prototype.$http = http;
  },
};
export default Http;
